<template>
    <v-stepper-content step="3">
        <v-dialog v-model="objDatosCorreoModal.abrirDialogo" persistent :max-width="tamModal">
            <v-card>
                <v-card-title class="bg-title-card">
                    <span class="white--text headline" v-html="objDatosCorreoModal.titulo"></span>
                </v-card-title>
                <v-form ref="form_datos_correo">
                    <v-container fluid grid-list-md>
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-autocomplete label="Tipo de Correo *" color="textbox"
                                    v-model="objDatosCorreoModal.idTipoCorreo" :items="listGeneral.listaTipoCorreos"
                                    item-value="idTipoCorreo" item-text="tipoCorreo" :rules="requeridoRegla" outlined dense />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field label="Para: *" color="textbox" v-model="objDatosCorreoModal.para"
                                    :rules="_.concat(requeridoRegla,emailRegla)" outlined dense />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-text-field label="CC: " color="textbox" v-model="objDatosCorreoModal.cc"
                                    :rules="_.size(objDatosCorreoModal.cc) > 0 ? emailRegla : []" outlined dense/>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-autocomplete label="Estado *" color="textbox" v-model="objDatosCorreoModal.idEstado"
                                    :items="listGeneral.listaEstados" item-value="id_estado" item-text="nombre_estado"
                                    :rules="requeridoRegla" outlined dense/>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col class="text-right">
                                <v-btn outlined rounded color="danger" class="mr-1" @click="salir">Salir</v-btn>
                                <v-btn rounded dark color="primary" @click="guardar">Guardar</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card>
        </v-dialog>
        <v-form ref="form_table_correos">
            <v-container fluid grid-list-md>
                <v-row dense>
                    <v-col cols="12" sm="6"/>
                    <v-col cols="12" sm="6">
                        <v-btn rounded dark color="primary" class="float-right" @click="objDatosCorreoModal.abrirDialogo=true">NUEVO</v-btn>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="6" />
                    <v-col cols="12" sm="6">
                        <v-text-field label="Buscar" color="textbox" v-model="objDatosCorreo.busqueda" clearable dense prepend-inner-icon="search"></v-text-field>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col xs12>
                        <v-data-table :search="objDatosCorreo.busqueda" :headers="listGeneral.cabeceraCorreos" :items="listGeneral.listaCorreos" class="elevation-3">
                            <template v-slot:item.accion="{ item }">
                                <v-icon small @click="onEditar(item)">edit</v-icon>
                            </template>

                            <template v-slot:pageText="props">
                                Registro del <span v-text="props.pageStart"></span> al <span
                                    v-text="props.pageStop"></span> de <span v-text="props.itemsLength"></span>
                            </template>

                            <template v-slot:no-results>
                                <v-alert :value="true" color="blue" icon="info" style="height:5%">
                                    Tu búsqueda de "<span v-text="objDatosCorreo.busqueda"></span>" no arrojó resultados.
                                </v-alert>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
                <v-row >
                    <v-col class="text-right">
                        <v-btn outlined rounded color="danger" class="mr-1" @click="previous">Anterior</v-btn>
                        <v-btn rounded dark color="primary" @click="validar">Siguiente</v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-form>
    </v-stepper-content>
</template>
<script>
    export default {
        props: ['cargar', 'objForm', 'listGeneral', 'parametros'],
        inject: ['onListar', 'previous', 'next'],
        data() {
            return {
                objDatosCorreo: {},
                objDatosCorreoModal: {
                    abrirDialogo: false,
                    titulo: 'Nuevo Correo',
                    idEstado: '1'
                },
                listaCorreos: []
            }
        },
        watch: {
            cargar() {
                this.objDatosCorreo = _.clone(this.objForm);
                // this.listaCorreos = this.listGeneral.listaCorreos;
                if (this.cargar && _.size(this.listGeneral.listaCorreos) == 0) {
                    this.cargaGeneral();
                }
            }
        },
        methods: {
            cargaGeneral() {
                var request = [
                                this.onListarCorreos(), 
                                this.onListarCatologo('LISTA_TIPO_CORREO', 'listaTipoCorreos')
                              ];

                Promise.all(request)
                    .then((respuesta) => {
                        if (_.size(this.listGeneral.listaTipoCorreos) > 0)
                            this.$set(this.listGeneral, 'listaTipoCorreos', _.filter(this.listGeneral.listaTipoCorreos, (o) => { return _.toUpper(o.visualiza) == _.toUpper('true') }));
                    })
                    .catch((e) => {
                        mensajesAlerta(e, 'E');
                    });

            },
            onListarCatologo(opcion, lista) {
                return this.onListar(`administrador/catalogo-estado/listar`, { 'opcion': opcion })
                           .then((respuesta) => {
                                if (_.size(_.get(respuesta,['data','data'],[])) > 0)
                                    this.$set(this.listGeneral, lista, respuesta.data.data)
                                else
                                    mensajesAlerta(respuesta.data.mensaje, 'E');

                                return respuesta;
                          });
            },
            onListarCorreos() {
                var objeto = {
                    'opcion': 'LISTAR_CORREOS',
                    'idProducto': this.objForm.idProducto,
                    'idEstado': '1'
                };

                return this.onListar(`administrador/producto/listar`, objeto)
                    .then((respuesta) => {
                        if (_.size(_.get(respuesta,['data','data'],[])) > 0)
                            this.$set(this.listGeneral, 'listaCorreos', respuesta.data.data);
                        else
                            mensajesAlerta(respuesta.data.mensaje, 'E');

                        return respuesta;
                    });
            },
            onEditar(objeto) {
                var index = _.findIndex(this.listGeneral.listaCorreos, (o) => { return parseInt(o.idTipoCorreo) == parseInt(objeto.idTipoCorreo) });
                this.objDatosCorreoModal = _.merge({}, this.objDatosCorreoModal,objeto, { titulo: 'Editar Correo',  index: index, abrirDialogo: true });
            },
            validar() {
                try {
                    if (_.size(this.listGeneral.listaCorreos) == 0) throw mensajeEstandar.faltaInformación;
                    var l = _.find(this.listGeneral.listaCorreos, (o) => { return parseInt(o.idTipoCorreo) == parseInt(this.parametros.idTipoCorreoAdministracion) });
                    if (_.size(l) == 0) throw mensajeEstandar.correoAdministracion;
                        this.next();
                } catch (e) {
                    mensajesAlerta(e, 'E');
                }
            },
            // Modal
            guardar() {
                try {
                    if (!this.$refs.form_datos_correo.validate()) throw mensajeEstandar.corregirInformacion;
                    this.objDatosCorreo = _.clone(this.objDatosCorreoModal);

                    if (_.isUndefined(this.objDatosCorreo.index)) {
                        if (this._validarInformacion(this.listGeneral.listaCorreos, null, this.objDatosCorreo.idTipoCorreo, 'idTipoCorreo')) throw mensajeEstandar.registroExistente;
                    } else {
                        if (this._validarInformacion(this.listGeneral.listaCorreos, this.objDatosCorreo.index, this.objDatosCorreo.idTipoCorreo, 'idTipoCorreo')) throw mensajeEstandar.registroExistente;
                    }

                    // Catalogo
                    var objTipoCorreo = _.find(this.listGeneral.listaTipoCorreos, (o) => {  return parseInt(o.idTipoCorreo) == parseInt(this.objDatosCorreo.idTipoCorreo) });

                    this.objDatosCorreo.tipoCorreo = _.size(objTipoCorreo.tipoCorreo) > 0 ? objTipoCorreo.tipoCorreo : '';

                    var objEstado = _.find(this.listGeneral.listaEstados, (o) => { return parseInt(o.id_estado) == parseInt(this.objDatosCorreo.idEstado) });

                    this.objDatosCorreo.estado = _.size(objEstado.nombre_estado) > 0 ? objEstado.nombre_estado : '';

                    if (_.isUndefined(this.objDatosCorreo.index))
                        this.listGeneral.listaCorreos.push(_.omit(this.objDatosCorreo, ['abrirDialogo', 'titulo']));
                    else {
                        var l = _.clone(this.listGeneral.listaCorreos);
                        l[this.objDatosCorreo.index] = _.merge(l[this.objDatosCorreo.index], _.omit(this.objDatosCorreo, ['abrirDialogo', 'titulo']));
                        this.$set(this.listGeneral, 'listaCorreos', l);
                    }

                    this.$forceUpdate();
                    this.salir();
                } catch (e) {
                    mensajesAlerta(e, 'E');
                }
            },
            salir() {
                this.objDatosCorreoModal = {
                    abrirDialogo: false,
                    titulo: 'Nuevo Correo',
                    idEstado: '1'
                };
                this.objDatosCorreo = {};
                this.$refs.form_datos_correo.resetValidation();
            }
        }
    }
</script>